"use client";

import { useEffect, useState } from "react";

export function usePortalHost(selector: string) {
  const [host, setHost] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let cancelled = false;

    const resolve = () => {
      const el = document.querySelector(selector) as HTMLElement | null;
      if (!cancelled) {
        if (el) {
          setHost((prev) => (prev === el ? prev : el));
        } else {
          setHost((prev) => prev);
        }
      }
      return el;
    };

    const first = resolve();
    if (first) return;

    const observer = new MutationObserver(() => {
      const el = resolve();
      if (el) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    return () => {
      cancelled = true;
      observer.disconnect();
    };
  }, [selector]);

  return host;
}

